<template>
  <div class="calculation">
    <ul>
      <li class="img_outer_layer">
        <img src="@/assets/images/ceyicehuodong.png" alt="" />
      </li>
      <li class="success_res" v-show="success_status">
        <img src="@/assets/images/success.png" alt="" />
        <div class="tip_one">恭喜您提交成功</div>
        <div class="tip_two">工作人员会尽快跟你联系</div>
      </li>
      <li class="centerInput" v-show="showRentPrise">
        <img
          class="small_icon phoneicon"
          src="@/assets/images/phoneicon.png"
          alt=""
        />
        <img
          class="small_icon testicon"
          src="@/assets/images/yanzhengmaicon.png"
          alt=""
        />
        <button
          @click.prevent="getCode()"
          class="code_btn getCode"
          :disabled="!show"
        >
          <span v-show="show">获取验证码</span>
          <span v-show="!show" class="count">{{ count }}秒后重试</span>
        </button>
        <van-field
          v-model="userphone"
          name="手机号"
          label=""
          maxlength="11"
          placeholder="手机号"
        />
        <van-field
          v-model="catCode"
          name="验证码"
          label=""
          maxlength="6"
          placeholder="验证码"
          :rules="[{ required: true, message: '验证码' }]"
        />
        <div class="privacy">
          <van-checkbox
            v-model="checked"
            shape="square"
            icon-size="14px"
            checked-color="#0079CC"
            >我已阅读并同意</van-checkbox
          >
          <span class="privacyProtocol" style="color: #0079CC" @click="privacyProtocol()"
            >《隐私协议》</span
          >
        </div>
        <div style="margin: 16px;">
          <van-button type="info" :disabled="disabled" @click="agreeAgreement">
            提交信息
          </van-button>
        </div>
      </li>
      <li class="lower_font">小望金科承诺，严格保障您的隐私安全</li>
    </ul>
    <div class="mark_dialog" v-show="showMark" @click="markDialog">
      <ul class="dialog">
        <li class="dialog_title">隐私协议</li>
        <li class="dialog_centent">
          <h4>
            本隐私政策介绍本公司的隐私数据相关政策和惯例，使我们在收集、使用、储存和传送个人资料方面符合
            (与个人资料私隐有关的法律法规)
            及消费者保护方面的最高标准。请你仔细阅读我们的隐私政策。
          </h4>
          一、本公司如何收集您的个人信息<br />
          经您同意，我们会收集、管理您的个人手机号码，您提交的手机号码为您与小望金科指定的联系方式之一，用来接受相关业务通知和服务跟踪。<br />
          二、本公司如何使用您的个人信息<br />
          1、通过您的手机号码实现密码找回功能。
          2、除本公司发生重组、合并或出售，可将我们收集的一切个人信息转让给相关第三方外，本公司不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本公司单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些信息。<br />
          三、个人信息安全<br />
          保证您的数据的安全对我们来说至关重要。当您在本公司的活动表单输入个人信息时，我们对这些信息进行加密。
          在数据传输和数据保管两个阶段里，我们会通过广为接受的行业标准（如防火墙、加密和数据隐私法律要求）来保护您向我们提交的信息。
          尽管实施了上述技术和保安的措施,
          我们不能保证资料在互联网上的输送绝对安全,
          因此我们不能绝对保证您通过我们网站提供给我们的个人资料在一切时候都是安全的。对任何因未经授权而接触您个人资料所发生的事件我们一概不承担责任,
          于这方面产生或导致的任何损失或损害, 我们也不负责赔偿。<br />
          四、本公司会将个人信息保存多久<br />
          一般来说，本公司仅在您使用小望金科服务期间保留您的个人信息，同时将遵守适用法律规定的数据保留期限。<br />
          五、法律免责声明<br />
          在法律要求的情况下（如协助公安机关）或遵守司法程序、法院指令，以及因用户行为而致使本公司的法定权益收到威胁，我们有权透露您的个人信息。
          如果本公司确定为了执行本公司的条款和条件或保护我们的经营，披露是合理必须的，则我们可能会披露与您有关的信息。<br />
          六、本隐私政策的更改<br />
          本公司会根据国家法律法规不定时（无需事先向您通知）更改本政策协议。任何对隐私政策的修改都会刊登在我们网站上。<br />
          七、隐私问题<br />
          如果您对本隐私政策内容有任何疑问和意见，或者您对本隐私政策的实践以及操作上有任何疑问和意见，您可随时通过客服电话（40085-12366）与我们联系。
        </li>
        <li class="submit" @click.stop="agreeAgreement(1)">同意并提交</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast } from 'vant';

export default {
  name: 'calculation',
  data() {
    return {
      checked: false,
      userphone: null,
      catCode: null,
      showRentPrise: true,
      success_status: false,
      showMark: false,
      show: true,
      timer: null,
      count: null,
      disabled: false,
    };
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#fff');
  },
  computed: {
    ...mapGetters({
      nextStep: 'calculation/nextStep',
    }),
  },
  watch: {
    nextStep(status) {
      if (status) {
        this.disabled = true;
        this.showRentPrise = false;
        this.success_status = true;
      }
    },
  },
  mounted() {},
  methods: {
    privacyProtocol() {
      this.showMark = true;
    },
    async agreeAgreement(val) {
      if (val === 1) {
        this.checked = true;
      }
      const reg = /^1\d{10}$/;
      if (this.userphone === null) {
        Toast('手机号不能为空！');
        this.showMark = false;
        return;
      } if (!reg.test(this.userphone)) {
        this.showMark = false;
        Toast('请输入正确手机号！');
        return;
      }
      const codeReg = /\d{6}/;
      if (this.catCode === null) {
        Toast('验证码不能为空！');
        this.showMark = false;
        return;
      } if (!codeReg.test(this.catCode)) {
        this.showMark = false;
        Toast('请输入正确的验证码！');
        return;
      }
      if (!this.checked) {
        this.showMark = false;
        Toast('请勾选协议！');
        return;
      }
      this.showMark = false;
      this.$store.dispatch('calculation/subUserInfo', {
        captcha: this.catCode,
        phone: this.userphone,
      });
    },
    markDialog(event) {
      if (event.currentTarget === event.target) {
        this.showMark = false;
      }
    },
    // 获取短信验证码
    getCode() {
      const reg = /^(1)\d{10}$/;
      if (this.userphone === null) {
        Toast('手机号不能为空！');
        return;
      } if (!reg.test(this.userphone)) {
        Toast('请输入正确的手机号码');
        return;
      }
      this.$store.state.calculation.phone = this.userphone;
      this.$store.dispatch('calculation/getCode');
      if (!this.timer) {
        // 验证码倒计时
        this.count = 60;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            // eslint-disable-next-line no-plusplus
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>
<style scoped>
.calculation >>> .van-checkbox__label {
  color: #a2abb7;
  font-weight: 400;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.img_outer_layer {
  width: 100%;
  height: 350px;
}
.img_outer_layer img {
  width: 100%;
  height: 100%;
}
.van-button--info {
  width: 85%;
  height: 44px;
  background: linear-gradient(
    180deg,
    rgba(245, 81, 74, 1) 0%,
    rgba(245, 104, 60, 1) 100%
  );
  border: none;
  border-radius: 8px;
}
ul {
  background: #fff;
}
.van-button__text {
  color: rgba(255, 255, 255, 1);
  font-weight: 400;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.lower_font {
  color: rgba(209, 209, 209, 1);
  font-weight: 400;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.privacyProtocol {
  color: #0079cc;
  font-size: 12px;
}
.privacy {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
  margin: 28px 0;
}
.van-checkbox {
  margin-left: 24px;
}
.calculation >>> .van-field__label {
  width: 36px;
}
.centerInput {
  position: relative;
  margin-bottom: 40px;
}
.small_icon {
  width: 23px;
  height: 23px;
}
.phoneicon {
  position: absolute;
  top: 16px;
  left: 22px;
  z-index: 3;
}
.testicon {
  position: absolute;
  top: 71px;
  left: 22px;
  z-index: 3;
}
.calculation >>> .van-cell {
  line-height: 34px;
}
.mark_dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.dialog {
  width: 80%;
  height: 405px;
  background: #fff;
  border-radius: 10px;
}
.dialog_title {
  height: 45px;
  color: rgba(28, 36, 56, 1);
  font-weight: 500;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 45px;
  border-bottom: 1px solid rgba(233, 234, 236, 1);
}
.dialog_centent {
  height: 295px;
  padding: 12px 20px;
  overflow-y: scroll;
  color: rgba(73, 80, 96, 1);
  font-weight: 400;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  text-align: left;
}
.dialog_centent h3 {
  text-align: center;
}
.submit {
  height: 45px;
  color: rgba(255, 255, 255, 1);
  font-weight: 400;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 45px;
  background: #ff6538;
  border-radius: 0 0 10px 10px;
}
.success_res {
  margin: 36px 0 71px 0;
}
.success_res img {
  width: 60px;
  height: 60px;
}
.tip_two {
  margin-top: 10px;
  color: #a1aab6;
  font-size: 14px;
}
.tip_one {
  margin-top: 16px;
  color: rgba(246, 82, 73, 1);
  font-weight: 500;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
}
.getCode {
  color: rgba(246, 82, 73, 1);
  font-weight: 400;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.code_btn {
  position: absolute;
  top: 54px;
  right: 14px;
  z-index: 3;
  width: auto;
  height: 52px;
  background: #fff;
  border: none;
}

.calculation >>> .van-field__control {
  font-size: 16px;
  letter-spacing: 3px;
  padding-left: 36px;
}
</style>
